var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcnBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#474847",
    d: "M16 14.68v.52c0 .442-.358.8-.8.8h-1.6C6.089 16 0 9.911 0 2.4V.8C0 .358.358 0 .8 0H4c.442 0 .8.358.8.8V4c0 .448-.248 1.048-.56 1.36L2.528 7.072c1.216 2.88 3.52 5.184 6.4 6.4l1.696-1.696c.32-.32.92-.568 1.36-.568H15.2c.439.004.792.361.792.8v2.68L16 14.68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcnBlack);
export default __webpack_public_path__ + "static/media/phone-icn-black.45e61f2e23bb1fafb866c10a998116a7.svg";
export { ForwardRef as ReactComponent };